import { z } from 'zod';

export const patientIntroFormSchema = z.object({
  phone: z.e164('Invalid phone number'),
});

const nameRegex = /^[\w@#\-()*'" ]+$/;

export const patientInformationSchema = z.object({
  id: z.string(),
  email: z.email(),
  phone: z.e164('Invalid phone number'),
  firstName: z
    .string()
    .min(1, 'First Name is required')
    .regex(nameRegex, 'Should be valid')
    .max(40, 'First Name is too long'),
  lastName: z
    .string()
    .min(1, 'Last Name is required')
    .regex(nameRegex, 'Should be valid')
    .max(80, 'Last Name is too long'),
  dateOfBirth: z.string().min(1, 'Date of Birth is required'),
  zipCode: z.string(),
  mrn: z
    .string()
    .min(1, 'Medical Record Number is required')
    .max(10, 'Medical Record Number is too long')
    .regex(
      /^[1-9]+[0-9]*$/,
      'Enter a valid medical record number. No leading zeroes.',
    ),
  invite: z.string(),
  sendInvite: z.boolean(),
});
